























import { Product, ProductsApi } from '../../api/api';
import { Component, Prop, Vue } from 'vue-property-decorator';
import Toast from '../display/toast.vue';
import SmsCurrentTabs from './smsCurrentTabs.vue';

@Component({
	components: {
		SmsCurrentTabs,
	},
})
export default class Charges extends Vue {
	@Prop({ type: Object, required: true })
	public product!: Product & { subscriptionitem?: { plan?: string } };
	@Prop({ type: Boolean, required: true })
	public isFeed!: boolean;

	public toast = new Toast();
	public smsCount: number = 0;
	public maxSmsCount: number = 0;
	private api: ProductsApi = new ProductsApi();

	get notificationsLimitNear(): boolean {
		return this.smsCount / this.maxSmsCount > 0.95;
	}

	public async created() {
		this.getAlertsData();
	}

	public async getAlertsData() {
		if (!this.product?.id) return;

		try {
			const smsStatus = await this.api.getSmsStatus(this.product.id);

			this.smsCount = smsStatus?.data?.data?.numSent ?? 0;
			this.maxSmsCount = smsStatus?.data?.data?.tierLimit ?? 0;
		} catch (e) {
			this.toast.makeToast('Error', 'There was a problem getting alert data.', 'danger', false);
		}
	}
}
